export enum ApiEvent {
  HOMEPAGE_VIEW = 'HOMEPAGE_VIEW',
  NEW_USER = 'NEW_USER',
  USER_LOGIN = 'USER_LOGIN',
  START_GAME = 'START_GAME',
  QUESTION_SENT = 'QUESTION_SENT',
  ANSWER_OPTION_PICKED = 'ANSWER_OPTION_PICKED',
  GAMEPLAY_TOKEN_USED = 'GAMEPLAY_TOKEN_USED',
  OFFER_POP_UP_VIEW = 'OFFER_POP_UP_VIEW',
  PAYMENT_REQUEST_FREE = 'PAYMENT_REQUEST_FREE',
  PAYMENT_REQUEST_CC = 'PAYMENT_REQUEST_CC',
  CHARGE_SAVED_CARD_REQUEST = 'CHARGE_SAVED_CARD_REQUEST',
  VPOS_START_PAYMENT_REQUEST = 'VPOS_START_PAYMENT_REQUEST',
  MOBILE_START_PAYMENT_REQUEST = 'MOBILE_START_PAYMENT_REQUEST',
  SAVE_CARD_REQUEST = 'SAVE_CARD_REQUEST',
  PAYMENT_SUCCESS_CC = 'PAYMENT_SUCCESS_CC',
  POINTS_REWARD_WALLET = 'POINTS_REWARD_WALLET',
  POINTS_REWARD_DIRECT = 'POINTS_REWARD_DIRECT',
  PLAY_AGAIN = 'PLAY_AGAIN',
  CONTINUE_BUTTON_CLICKED = 'CONTINUE_BUTTON_CLICKED',
  OFFER_MOBILE_PAYMENT = 'OFFER_MOBILE_PAYMENT',
  OFFER_CREDIT_CARD = 'OFFER_CREDIT_CARD',
  OFFER_SINGLE = 'OFFER_SINGLE',
  OFFER_TRIPLE = 'OFFER_TRIPLE',
}
